import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const ACCOUNT_QUERY = gql`
  query AccountQuery {
    accountInfo {
      accountUuid
      accountEmail
      accountPhone
      firstName
      middleName
      lastName
      suffix
      allPartnerOptOut
      userAuth0Id
    }
  }
`;

export function useAccountSettings() {
  const { data, loading, error, refetch } = useQuery(ACCOUNT_QUERY, {
    noThrow: true,
  });

  useError(error);

  return {
    data: data?.accountInfo || {},
    error,
    loading,
    refetch,
  };
}
